// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSubscriptionbutton_root__ro4kb","text":"PlasmicSubscriptionbutton_text__OuFcu"};